import styled from 'styled-components'

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  color: ${props => props.theme.colors.text.default};

  img {
    width: 30px;
    aspect-ratio: 4 / 3;
    object-fit: contain;
  }

  .MuiSelect-select & {
    vertical-align: middle;

    img {
      width: auto;
      height: ${props => props.theme.size.XXS};
    }
  }
`

export const TypeContainer = styled.div`
  width: ${props => props.theme.size.XXS};

  svg {
    color: ${props => props.theme.colors.text.default};
  }

  :first-child {
    display: block;
  }
`
